import { render, staticRenderFns } from "./PurchaseAnalysis.vue?vue&type=template&id=64746631&"
import script from "./PurchaseAnalysis.vue?vue&type=script&lang=js&"
export * from "./PurchaseAnalysis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports